module.exports = __webpack_public_path__ + "static/media/uncheckedCheckbox.9e17076a.svg";